(function () {
  'use strict';

  function localizeTypeLabel(label) {
    var language = String(document.documentElement.lang || 'sk').toLowerCase().split('-')[0];
    var translations = {
      de: {
        'Živá rastlina': 'Lebende Pflanze', 'Kvetináč': 'Pflanzgefäß', 'Umelá rastlina': 'Kunstpflanze', 'Umelý strom': 'Kunstbaum',
        'Visiaca rastlina': 'Hängepflanze', 'Zelený stenový panel': 'Grünwandpaneel', 'Vetva a stonka': 'Zweig und Stiel', 'Kytica': 'Blumenstrauß',
        'Girlanda': 'Girlande', 'Umelý živý plot': 'Kunsthecke', 'Dekoratívny list': 'Dekoratives Blatt', 'Produkt': 'Produkt', 'Príslušenstvo': 'Zubehör'
      },
      fr: {
        'Živá rastlina': 'Plante naturelle', 'Kvetináč': 'Pot de fleurs', 'Umelá rastlina': 'Plante artificielle', 'Umelý strom': 'Arbre artificiel',
        'Visiaca rastlina': 'Plante retombante', 'Zelený stenový panel': 'Panneau végétal', 'Vetva a stonka': 'Branche et tige', 'Kytica': 'Bouquet',
        'Girlanda': 'Guirlande', 'Umelý živý plot': 'Haie artificielle', 'Dekoratívny list': 'Feuille décorative', 'Produkt': 'Produit', 'Príslušenstvo': 'Accessoires'
      }
    };
    return translations[language] && translations[language][label] ? translations[language][label] : label;
  }

  function classifyTitle(title, currentType) {
    var value = String(title || '').toLowerCase();
    var type = String(currentType || '').trim();
    var labels = {
      'Live Plant': 'Živá rastlina',
      'Pot': 'Kvetináč',
      'Planter': 'Kvetináč',
      'Artificial Plant': 'Umelá rastlina',
      'Artificial Tree': 'Umelý strom',
      'Hanging Plant': 'Visiaca rastlina',
      'Green Wall Panel': 'Zelený stenový panel',
      'Branch & Stem': 'Vetva a stonka',
      'Bouquet': 'Kytica',
      'Artificial Bouquet': 'Kytica',
      'Garland': 'Girlanda',
      'Artificial Garland': 'Girlanda',
      'Hedge': 'Umelý živý plot',
      'Artificial Hedge': 'Umelý živý plot',
      'Leaf': 'Dekoratívny list',
      'Artificial Leaf': 'Dekoratívny list',
      'Standard': 'Produkt',
      'Náhradní díly pro plynové grily': 'Náhradné diely pre plynové grily',
      'Příslušenství': 'Príslušenstvo',
      'Popolnice': 'Odpadkové nádoby',
      'Rudlíky': 'Manipulačné vozíky',
      'Záhradný fúriky': 'Záhradné fúriky',
      'Mulčovacia textílie': 'Mulčovacie textílie',
      'Tieniace sieť': 'Tieniace siete',
      'Drviče vetví': 'Drviče konárov',
      'Benzinové píly': 'Benzínové píly',
      'Trávne zmesy': 'Trávne zmesi'
    };
    var artificial =
      value.indexOf('kunstplant -') !== -1 ||
      value.indexOf('- kunstplant') !== -1 ||
      value.indexOf('kunstbloemen -') !== -1 ||
      value.indexOf('- kunstbloemen') !== -1 ||
      value.indexOf('artificial') !== -1;

    if (type === 'Plant' || type === 'Živá rastlina') return localizeTypeLabel(artificial ? 'Umelá rastlina' : 'Živá rastlina');
    if (labels[type]) return localizeTypeLabel(labels[type]);
    return localizeTypeLabel(type || 'Produkt');
  }

  function updatePredictiveSearchLabels(scope) {
    (scope || document).querySelectorAll('.botanicalis-predictive__option').forEach(function (option) {
      var type = option.querySelector('.botanicalis-predictive__type');
      var title = option.querySelector('.botanicalis-predictive__title');
      if (!type || !title) return;
      var label = classifyTitle(title.textContent, type.textContent);
      if (type.textContent !== label) type.textContent = label;
    });
  }

  function updateSelectionMail() {
    var link = document.querySelector('[data-selection-mail]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('BOTANICALIS') !== -1) link.setAttribute('href', href.replace(/BOTANICALIS/g, 'TERAVIA'));
  }

  function init() {
    updatePredictiveSearchLabels(document);
    updateSelectionMail();

    var observer = new MutationObserver(function (mutations) {
      var shouldUpdateSearch = false;
      var shouldUpdateMail = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          shouldUpdateSearch = true;
        }
        if (mutation.type === 'attributes' && mutation.target.matches && mutation.target.matches('[data-selection-mail]')) shouldUpdateMail = true;
        if (mutation.type === 'childList' && mutation.target.closest && mutation.target.closest('[data-drawer-products]')) shouldUpdateMail = true;
      });
      if (shouldUpdateSearch) updatePredictiveSearchLabels(document);
      if (shouldUpdateMail) updateSelectionMail();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
